module.exports = __webpack_public_path__ + "img/item-3.0fc887b.svg";